import {Component, forwardRef, Input} from '@angular/core';
import {ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, NgForm} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';


@Component({
	selector: 'ui-input',
	template: `
		<div class="ui-input" [ngSwitch]="metadata?.type?metadata?.type:'default'">
			<ui-label *ngSwitchCase="'label'" [label]="metadata.label">
			</ui-label>
			<ui-input-default
				*ngSwitchDefault
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-default>

			<ui-input-text
				*ngSwitchCase="'text'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-text>

			<ui-input-number
				*ngSwitchCase="'number'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-number>

			<ui-input-radio
				*ngSwitchCase="'radio'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-radio>

			<ui-input-checkboxes
				*ngSwitchCase="'checkboxes'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-checkboxes>


			<ui-input-checkbox
				*ngSwitchCase="'checkbox'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-checkbox>

			<ui-input-dropdown
				*ngSwitchCase="'dropdown'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-dropdown>

			<ui-input-yes-no
				*ngSwitchCase="'yes_no'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-yes-no>

			<ui-input-datepicker
				*ngSwitchCase="'date'"
				[(ngModel)]="cva.value"
				(ngModelChange)="writeValueFromInput($event)"
				[name]="name"
				[metadata]="metadata"
				[presentationMode]="presentationMode"
			></ui-input-datepicker>
		</div>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputComponent),
			multi: true
		},
		{provide: ControlContainer, useExisting: NgForm}
	]
})
export class UIInputComponent extends CVA {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() presentationMode = false;
}
